<!-- IF textarea is required -->
<mat-form-field [ngClass]="(positionField === field && onBuilder) ? 'active-control' : ''" *ngIf="formInfos.required">
    <mat-label>{{formInfos.name}}</mat-label>
    <textarea matInput placeholder="{{formInfos.placeholder}}" [(ngModel)]="value" name="textarea" #textarea="ngModel"
        required (input)="textareaValidator($event)">
    </textarea>
    <mat-error *ngIf="textarea.valid || textarea.pristine">
        {{formInfos.requiredAlertMessage ? formInfos.requiredAlertMessage : formInfos.name + ' is required'}}.
    </mat-error>
    <mat-hint *ngIf="errorMessage">
        {{errorMessage}}
    </mat-hint>
</mat-form-field>
<!-- IF textarea is not required -->
<mat-form-field [ngClass]="(positionField === field && onBuilder) ? 'active-control' : ''" *ngIf="!formInfos.required">
    <mat-label>{{formInfos.name}}</mat-label>
    <textarea matInput placeholder="{{formInfos.placeholder}}" (input)="textareaValidator($event)" [(ngModel)]="value">
    </textarea>
</mat-form-field>